import {
  AccessRequestDTO,
  CreateAccessResponse,
} from "@/services/dtos/accessRequest.dto";
import type { AnyAccessDetails, IUnlockDetails } from "@/@types/unlock-request";

export const readUnlockDetails = (
  row: Pick<AccessRequestDTO, "access_details">,
): IUnlockDetails | null => {
  const details: AnyAccessDetails = row.access_details;
  if (!details || !("unlock" in details)) return null;

  return details.unlock ?? null;
};

export const readAccessDetails = (
  details: AnyAccessDetails,
): CreateAccessResponse | null => {
  if (!details || "unlock" in details) return null;

  return details;
};
